import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import '../../styles/signatureRejectedBr.css';
import { useMetadata } from '../../hooks/useMetadata';
import { hasSignatureError, isUserCancelledSignatureError } from '../../utils/signatureAttempt';

const SignatureRejectedPageBR: React.FC = () => {
  useMetadata();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const error = searchParams.get('error');
  const message = searchParams.get('message') || '';
  const quoteID = searchParams.get('quoteID') || searchParams.get('quoteId');

  const isCancel = isUserCancelledSignatureError(error);
  // A non-cancel `error` (Logalty numeric codes such as 99932) is a technical
  // failure, not the client rejecting the signature.
  const isTechnical = hasSignatureError(error) && !isCancel;
  // Retome por link con la solicitud ya en suscripción: discriminante explícito, para no depender
  // de un string de error.
  const isSubmitted = searchParams.get('state') === 'submitted';
  // Error de pago del callback de la firma: el postulante volvió a firmar y ya había una firma
  // registrada. Habla de la firma, no de la solicitud, así que no comparte copy con `isSubmitted`.
  const isAlreadySigned = message.includes('subscription unique violation');

  const handleResume = () => {
    if (quoteID) {
      navigate(`/signature?quoteID=${quoteID}&retry=1`);
    }
  };

  return (
    <div className="br-rejected-page">
      <header className="br-rejected-header">
        <img
          src="/logo_official.svg"
          alt="Olé Logo"
          className="br-rejected-logo"
        />
      </header>
      <main className="br-rejected-body">
        {isSubmitted ? (
          <>
            <img
              src="/icon-sign-signed-br.svg"
              alt="Solicitação recebida"
              className="br-rejected-icon"
            />
            <h1 data-testid="br-enviada-titulo-solicitud" className="br-rejected-title">
              Solicitação enviada
            </h1>
            <p data-testid="br-enviada-texto-descripcion" className="br-rejected-description">
              Recebemos sua solicitação e ela já está em análise. Não é necessário fazer mais nada:
              avisaremos você assim que tivermos o resultado.
            </p>
          </>
        ) : isAlreadySigned ? (
          <>
            <img
              src="/icon-sign-signed-br.svg"
              alt="Assinatura recebida"
              className="br-rejected-icon"
            />
            <h1 data-testid="br-obrigado-titulo-solicitud" className="br-rejected-title">
              Obrigado por assinar!
            </h1>
            <p data-testid="br-obrigado-texto-descripcion" className="br-rejected-description">
              Recebemos sua nova assinatura com sucesso. Não é necessário fazer mais nada.
            </p>
          </>
        ) : isTechnical ? (
          <>
            <img
              src="/icon-sign-pending-br.svg"
              alt="Assinatura pendente"
              className="br-rejected-icon"
            />
            <h1 data-testid="br-tecnico-titulo-solicitud" className="br-rejected-title">
              Não conseguimos conectar com a assinatura
            </h1>
            <p data-testid="br-tecnico-texto-descripcion" className="br-rejected-description">
              Houve um problema técnico e a assinatura não foi concluída. Sua solicitação continua aberta: você pode tentar de novo.
            </p>
            {quoteID && (
              <button
                onClick={handleResume}
                data-testid="br-tecnico-boton-retomar"
                className="br-rejected-button"
              >
                Tentar novamente
              </button>
            )}
          </>
        ) : isCancel ? (
          <>
            <img
              src="/icon-sign-pending-br.svg"
              alt="Assinatura pendente"
              className="br-rejected-icon"
            />
            <h1 data-testid="br-pendente-titulo-solicitud" className="br-rejected-title">
              Sua assinatura está pendente
            </h1>
            <p data-testid="br-pendente-texto-descripcion" className="br-rejected-description">
              A assinatura da sua apólice foi adiada, mas você pode retomá-la agora mesmo e concluir o processo em poucos minutos.
            </p>
            {quoteID && (
              <button
                onClick={handleResume}
                data-testid="br-pendente-boton-retomar"
                className="br-rejected-button"
              >
                Retomar assinatura
              </button>
            )}
          </>
        ) : (
          <>
            <img
              src="/icon-sign-rejected-br.png"
              alt="Assinatura rejeitada"
              className="br-rejected-icon"
            />
            <h1 data-testid="br-rechazo-titulo-solicitud" className="br-rejected-title">
              Você rejeitou a assinatura da sua solicitação
            </h1>
            <p data-testid="br-rechazo-texto-descripcion" className="br-rejected-description">
              Lamentamos informar que, ao rejeitar a assinatura eletrônica, sua{' '}
              <b>solicitação foi cancelada</b> por você.
            </p>
            <p data-testid="br-rechazo-texto-nueva-solicitud" className="br-rejected-description br-rejected-description--spaced">
              Você pode iniciar uma nova solicitação a qualquer momento.
            </p>
          </>
        )}
      </main>
    </div>
  );
};

export default SignatureRejectedPageBR;

